import $ from "jquery";

$(document).ready(function() {
	$('.jsFileItemNative').on('change', function () {
		const parent = $(this).closest('.jsFileItem');

		parent.find('.jsFileItemLabel').fadeOut(250, function () {
			parent.find('.jsFileItemSuccess').fadeIn(250);
		});
		parent.find('.jsFileItemSuccessName').html(this.files[0].name);
		parent.removeClass('is-error')

	});



	$('.jsFileItemDelete').on('click', function () {
		const parent = $(this).closest('.jsFileItem');

		parent.find('.jsFileItemNative').val('');
		parent.find('.jsFileItemSuccess').fadeOut(250, function () {
			parent.find('.jsFileItemLabel').fadeIn(250);
		});
	});
})




